import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardHeading: {
      paddingLeft: theme.spacing(1),
      color: theme.palette.grey["600"],
    },
    buttonEnd: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "flex-end",
    },
  })
);
